import SearchBlock from "./SearchBlock";

export default SearchBlock;
